import React from 'react';
import PropTypes from 'prop-types';

import {greyishBlue200} from "assets/jss/main";

CarouselNavButton.propTypes = {
    variant: PropTypes.oneOf(['left', 'right']),
    onClick: PropTypes.func
};

function CarouselNavButton({variant = 'left', onClick = () => {}}) {
    return (
        <div
            onClick={onClick}
            style={{
                position: 'absolute',
                ...variant === 'left' && {
                    left: 0,
                },
                ...variant === 'right' && {
                    right: 0,
                },
                top: '32px',
                background: '#fff',
                width: '40px',
                height: '40px',
                borderRadius: '8px',
                border: `1px solid ${greyishBlue200}`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
            {variant === 'left' ? (
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.99998 13.28L5.65331 8.93333C5.13998 8.42 5.13998 7.58 5.65331 7.06667L9.99998 2.72" stroke="#333333" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            ) : (
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.93994 13.28L10.2866 8.93333C10.7999 8.42 10.7999 7.58 10.2866 7.06667L5.93994 2.72" stroke="#333333" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            )}
        </div>
    );
}

export default CarouselNavButton;
